module.exports = __webpack_public_path__ + "assets/img/logo-eternia-services.06c80283.png";